module.exports = __webpack_public_path__ + "img/9ba685f.png";